<div class="content">
  <div *ngIf="!fullWidthTitle" class="prefix-wrapper header-item">
    <div class="align-wrapper">
      <ng-content select="[prefix]"></ng-content>
    </div>
  </div>

  <div class="content-wrapper header-item">
    <rt-truncate>
      <ng-content></ng-content>
    </rt-truncate>
  </div>

  <div *ngIf="!fullWidthTitle" class="suffix-wrapper header-item">
    <div class="align-wrapper">
      <ng-content select="[suffix]"></ng-content>
    </div>
  </div>
</div>

<rt-divider></rt-divider>
